import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const profile = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    fullName: z.string().nullable().optional().describe('Full Name'),

    alias: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Alias - Public display name shown in discussions and other public contexts',
      ),

    userId: z.number().hidden().describe('Foreign key to User'),

    user: belongsTo('User'),
  })
  .describe(
    'User profile with personal information. Each user has one profile.',
  )
  .as('Profile');

export { profile as profileSchema };
